import { render, staticRenderFns } from "./MenuActions.vue?vue&type=template&id=209ba857"
import script from "./MenuActions.vue?vue&type=script&lang=js"
export * from "./MenuActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ScMainNav: require('/opt/build/repo/node_modules/@evince/site/lib/packages/MainNav.vue').default,UserSession: require('/opt/build/repo/components/UserSession.vue').default,EshopCartToggle: require('/opt/build/repo/node_modules/@evince/eshop/lib/packages/CartToggle.vue').default,ScLangSwitcher: require('/opt/build/repo/node_modules/@evince/site/lib/packages/LangSwitcher.vue').default,SearchInput: require('/opt/build/repo/components/SearchInput.vue').default,ScMobileMenu: require('/opt/build/repo/node_modules/@evince/site/lib/packages/MobileMenu.vue').default})
